export default "__VITE_PUBLIC_ASSET__e908cd45__"